import * as axios from '../../axios-extended'
import * as t from 'io-ts'
import { NewOrganizationInvoice, NewSupplierInvoice } from '../../types'

const apiUrl = '/prosperbill/api'

export const addInvoices = (
  invoices: NewOrganizationInvoice[],
  organization: string,
  cancelToken?: axios.CancelToken
) =>
  axios.post(`${apiUrl}/invoices/${organization}/batch`, invoices, {
    decoder: t.unknown,
    cancelToken,
  })

export const addSupplierInvoices = (
  invoices: NewSupplierInvoice[],
  organization: string,
  cancelToken?: axios.CancelToken
) =>
  axios.post(`${apiUrl}/invoices/${organization}/supplier/batch`, invoices, {
    decoder: t.unknown,
    cancelToken,
  })
